import React from 'react'

import { StyledTextInput } from 'components/FormContainer/styled-components'
import { TestIDs } from 'test/utils/testIds'

import AutoCompleteList from './AutoCompleteList'
import enhance from './enhance'
import { InputAndSuggestion } from './styled-components'
import { InnerProps } from './types'

export const AutoCompleteAddress: React.SFC<InnerProps> = props => (
  <InputAndSuggestion>
    <StyledTextInput
      className="text-input"
      label={{
        value: 'Address',
      }}
      inputProps={{
        name: props.name,
        value: props.values[props.name],
        onChange: props.handleStreamChange,
        id: props.name,
        type: 'text',
        placeholder: props.placeholder,
        autoComplete: 'arbitraryToDisableBrowserProp',
      }}
      error={props.errors[props.name]}
      errorText={props.errors[props.name]}
      data-testid={TestIDs.CONTACT_INFO.ADDRESS_LINE_1}
    />
    {props.addressAutoCompleteOptions && (
      <AutoCompleteList
        suggestions={props.addressAutoCompleteOptions}
        onClickOutside={props.handleClickOutside}
        onSelect={props.handleAutoCompleteSelect}
      />
    )}
  </InputAndSuggestion>
)

export default enhance(AutoCompleteAddress)
